// Version : 0.0.2
// Author : DINESH
// MODFIED DATA : 08-08-2025

const productActionTypes = {
	/** ***************** ADD PRODUCT DETAILS START *********************** */
	ADD_PRODUCT_DETAILS_START: 'add_product_details_start',
	ADD_PRODUCT_DETAILS_SUCCESS: 'add_product_details_success',
	ADD_PRODUCT_DETAILS_FAILURE: 'add_product_details_failure',
	ADD_PRODUCT_DETAILS_RESPONSE_RESET: 'add_product_details_response_reset',
	ADD_PRODUCT_DETAILS_RESPONSE_CHANGED: 'add_product_details_response_changed',
	/** ***************** ADD PRODUCT DETAILS END *********************** */

	/** ***************** UPDATE PRODUCT DETAILS_START *********************** */
	UPDATE_PRODUCT_DETAILS_START: 'update_product_details_start',
	UPDATE_PRODUCT_DETAILS_SUCCESS: 'update_product_details_success',
	UPDATE_PRODUCT_DETAILS_FAILURE: 'update_product_details_failure',
	UPDATE_PRODUCT_DETAILS_RESPONSE_RESET: 'update_product_details_response_reset',
	UPDATE_PRODUCT_DETAILS_RESPONSE_CHANGED: 'update_product_details_response_changed',
	/** ***************** UPDATE PRODUCT DETAILS END *********************** */

	/** ***************** GET PRODUCT LIST START *********************** */
	GET_PRODUCT_LIST_START: 'get_product_list_start',
	GET_PRODUCT_LIST_SUCCESS: 'get_product_list_success',
	GET_PRODUCT_LIST_FAILURE: 'get_product_list_failure',
	GET_PRODUCT_LIST_RESPONSE_RESET: 'get_product_list_response_reset',
	GET_PRODUCT_LIST_RESPONSE_CHANGED: 'get_product_list_response_changed',
	/** ***************** GET PRODUCT LIST END *********************** */

	/** ***************** GET PRODUCT DETAILS LIST START *********************** */
	GET_PRODUCT_DETAILS_LIST_START: 'get_product_details_list_start',
	GET_PRODUCT_DETAILS_LIST_SUCCESS: 'get_product_details_list_success',
	GET_PRODUCT_DETAILS_LIST_FAILURE: 'get_product_details_list_failure',
	GET_PRODUCT_DETAILS_LIST_RESPONSE_RESET: 'get_product_details_list_response_reset',
	GET_PRODUCT_DETAILS_LIST_RESPONSE_CHANGED: 'get_product_details_list_response_changed',
	/** ***************** GET PRODUCT DETAILS LIST END *********************** */

	/** ***************** FETCH PRODUCT DETAILS START *********************** */
	FETCH_PRODUCT_DETAILS_START: 'fetch_product_details_start',
	FETCH_PRODUCT_DETAILS_SUCCESS: 'fetch_product_details_success',
	FETCH_PRODUCT_DETAILS_FAILURE: 'fetch_product_details_failure',
	FETCH_PRODUCT_DETAILS_RESPONSE_RESET: 'fetch_product_details_response_reset',
	FETCH_PRODUCT_DETAILS_RESPONSE_CHANGED: 'fetch_product_details_response_changed',
	/** ***************** FETCH PRODUCT DETAILS END *********************** */

	/** ***************** FETCH CUSTOM PRODUCT DETAILS START *********************** */
	FETCH_CUSTOM_PRODUCT_DETAILS_START: 'fetch_custom_product_details_start',
	FETCH_CUSTOM_PRODUCT_DETAILS_SUCCESS: 'fetch_custom_product_details_success',
	FETCH_CUSTOM_PRODUCT_DETAILS_FAILURE: 'fetch_custom_product_details_failure',
	FETCH_CUSTOM_PRODUCT_DETAILS_RESPONSE_RESET: 'fetch_custom_product_details_response_reset',
	FETCH_CUSTOM_PRODUCT_DETAILS_RESPONSE_CHANGED: 'fetch_custom_product_details_response_changed',
	/** ***************** FETCH CUSTOM PRODUCT DETAILS END *********************** */

	/** ***************** DELETE PRODUCT DETAILS START *********************** */
	DELETE_PRODUCT_DETAILS_START: 'delete_product_details_start',
	DELETE_PRODUCT_DETAILS_SUCCESS: 'delete_product_details_success',
	DELETE_PRODUCT_DETAILS_FAILURE: 'delete_product_details_failure',
	DELETE_PRODUCT_DETAILS_RESPONSE_RESET: 'delete_product_details_response_reset',
	DELETE_PRODUCT_DETAILS_RESPONSE_CHANGED: 'delete_product_details_response_changed',
	/** ***************** DELETE PRODUCT DETAILS END *********************** */

	/** ***************** GET MATSER ACCOUNT LIST START ************************/
	GET_MASTER_ACCOUNT_LIST_START: 'get_master_account_list_start',
	GET_MASTER_ACCOUNT_LIST_SUCCESS: 'get_master_account_list_success',
	GET_MASTER_ACCOUNT_LIST_FAILURE: 'get_master_account_list_failure',
	GET_MASTER_ACCOUNT_LIST_RESPONSE_RESET: 'get_master_account_list_response_reset',
	GET_MASTER_ACCOUNT_LIST_RESPONSE_CHANGED: 'get_master_account_list_response_changed',
	/** ***************** GET MATSER ACCOUNT LIST END *********************** */

	/** *********************  START GET ALL INSTRUMENT LIST  ******************** */
	GET_ALL_INSTRUMENT_LIST_START: 'get_all_instrument_list_start',
	GET_ALL_INSTRUMENT_LIST_SUCCESS: 'get_all_instrument_list_success',
	GET_ALL_INSTRUMENT_LIST_FAILURE: 'get_all_instrument_list_failure',
	GET_ALL_INSTRUMENT_LIST_RESPONSE_RESET: 'get_all_instrument_list_response_reset',
	GET_ALL_INSTRUMENT_LIST_RESPONSE_CHANGED: 'get_all_instrument_list_response_changed',
	/** *********************  END GET ALL INSTRUMENT LIST  ******************** */

	/** ***************** FETCH FILTER PRODUCT LIST START *********************** */
	FETCH_FILTER_PRODUCT_LIST_START: 'fetch_filter_product_list_start',
	FETCH_FILTER_PRODUCT_LIST_SUCCESS: 'fetch_filter_product_list_success',
	FETCH_FILTER_PRODUCT_LIST_FAILURE: 'fetch_filter_product_list_failure',
	FETCH_FILTER_PRODUCT_LIST_RESPONSE_RESET: 'fetch_filter_product_list_response_reset',
	FETCH_FILTER_PRODUCT_LIST_RESPONSE_CHANGED: 'fetch_filter_product_list_response_changed',
	/** ***************** FETCH FILTER PRODUCT LIST END *********************** */
};
export default productActionTypes;
